import { order } from '@schuettflix/schema-registry-ts';
import { z } from 'zod';

const IsoDatetimeMaybeRangeRegistrySchema = order.shared.versions.v1.schemas.IsoDatetimeMaybeRange;

export const IsoDatetimeMaybeRangeSchema = IsoDatetimeMaybeRangeRegistrySchema.or(z.coerce.date());

export type IsoDatetimeMaybeRange = z.infer<typeof IsoDatetimeMaybeRangeSchema> | Date;

export const IsoDatetimeRangeSchema = IsoDatetimeMaybeRangeSchema.transform((data: IsoDatetimeMaybeRange | Date) => {
    if (typeof data === 'string') {
        return {
            start: new Date(data),
            end: new Date(data),
        };
    }
    if (data instanceof Date) {
        return {
            start: data,
            end: data,
        };
    }
    return {
        start: new Date(data.start),
        end: new Date(data.end),
    };
});

export type IsoDatetimeRange = z.infer<typeof IsoDatetimeRangeSchema>;
